import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaxesTabService {
  private onEventSubject = new BehaviorSubject<string>('');
  public onEvent$: Observable<string> = this.onEventSubject.asObservable();

  constructor() {}

  onEvent(event: string): void {
    this.onEventSubject.next(event);
  }
}